<template>
  <div>
    <Modal title="Title" v-model="show" :mask-closable="false" class-name="vertical-center-modal">
      <div slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>告警规则</span>
      </div>
      <div slot="close">
        <Icon type="ivu-icon ivu-icon-ios-close"></Icon>
      </div>
      <div class="bind" style="position: relative;">
        <RadioGroup v-model="phone" vertical @on-change="bangding()">
          <Radio v-for="item in zdlist" :key="item.id" :label="item.id">
            <span style="margin-right:20px;font-size:14px;">{{ item.remark }}</span>
            <span>最大到最小：</span>
            <span style="color:orange">{{ item.faMin }}-</span>
            <span style="color:orange">{{ item.faMax }}</span>

            <Icon
              type="ios-backspace"
              v-if="item.id == phone"
              style="font-size: 16px;color: red;margin-left:10px;"
              @click="jiebang()"
            />
          </Radio>
        </RadioGroup>
        <div v-if="!zdlist || zdlist.length==0">暂无规则</div>
        <Page
          :total="zdlist_total"
          size="small"
          :current.sync="currentpage"
          @on-change="zdlist_change"
          v-if="zdlist && zdlist.length!=0"
        />
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zdlist: [], // 规则列表
      zdlist_total: null,
      currentpage: 1,
      spinShow: true,
      phone: null,
      show: false,
      deviceId: null
    };
  },
  created() {
    this.getbinded();
  },
  methods: {
    getbinded(params) {
      params = params || {};
      let self = this;
      self.spinShow = true;
      self.$api.Warn.getWarnRoleList(
        {
          content: { enabled: "true" },
          pageCurrent: params.pageCurrent || 1,
          pageSize: 10
        },
        ["uuid", "company"]
      ).then(result => {
        if (result.code == 0) {
          self.zdlist = result.data.list;
          self.zdlist_total = result.data.total;
          self.spinShow = false;
        }
      });
    },
    getNowWarn() {
      let self = this;
      self.$api.Warn.getWarnRule(
        {
          content: { deviceId: self.deviceId }
        },
        ["uuid", "company"]
      ).then(result => {
        if (result.code == 0) {
          if (result.data.length > 0) {
            self.phone = result.data[0].id;
          } else {
            self.phone = "";
          }
        }
      });
    },
    bangding() {
      let self = this;
      self.spinShow = true;
      if (this.phone) {
        self.$api.Warn.postWarnBinding(
          {
            content: {
              ruleId: this.phone,
              deviceId: this.deviceId
            }
          },
          ["uuid", "company"]
        ).then(result => {
          if (result.code == 0) {
            self.spinShow = false;
            this.$Notice.success({
              title: "绑定成功",
              desc: "绑定成功。。。"
            });
          } else {
            this.$Notice.warning({
              title: "绑定失败",
              desc: result.message || "请联系管理员"
            });
          }
        });
      } else {
      }
    },
    jiebang() {
      let self = this;
      self.spinShow = true;
      if (this.phone) {
        self.$api.Warn.postWarnNotBind(
          {
            content: { ruleId: this.phone, deviceId: this.deviceId }
          },
          ["uuid", "company"]
        ).then(result => {
          if (result.code == 0) {
            self.phone = "";
            self.spinShow = false;
            this.$Notice.success({
              title: "解绑成功",
              desc: "解绑成功。。。"
            });
          } else {
            this.$Notice.warning({
              title: "绑定失败",
              desc: result.message || "请联系管理员"
            });
          }
        });
      } else {
      }
    },
    zdlist_change(size) {
      this.getbinded({
        pageCurrent: size
      });
    }
  }
};
</script>